import React from "react";

/**
 * TOVRA wordmark / lockup.
 * Rendered with a stacked accent square + typography.
 */
export default function BrandMark({ theme = "light", logoUrl = null, tenantName = null, size = "md" }) {
  const dark = theme === "dark";
  const dim = size === "sm" ? { box: 26, text: "text-[13px]", sub: "text-[9px]" } : { box: 32, text: "text-[15px]", sub: "text-[10px]" };
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-mark">
      <div
        className="rounded-lg flex items-center justify-center font-black tracking-tight overflow-hidden"
        style={{
          width: dim.box, height: dim.box,
          background: dark ? "linear-gradient(135deg,#D95D39 0%,#F08A5D 100%)" : "#0f0f10",
          color: "white",
          boxShadow: dark ? "0 4px 12px rgba(217,93,57,0.35)" : "0 2px 6px rgba(0,0,0,0.12)",
        }}
        aria-hidden
      >
        {logoUrl ? <img src={logoUrl} alt="" className="w-full h-full object-cover"/> : <span style={{fontSize: dim.box * 0.5, lineHeight: 1}}>T</span>}
      </div>
      <div className="leading-tight">
        <div className={`${dim.text} font-black tracking-[0.02em] ${dark ? "text-white" : "text-zinc-900"}`}>TOVRA</div>
        <div className={`${dim.sub} tracking-[0.22em] font-medium ${dark ? "text-zinc-500" : "text-zinc-500"}`}>
          {tenantName ? tenantName.toUpperCase() : "WORK TOGETHER"}
        </div>
      </div>
    </div>
  );
}
